import {
  useMultiPlatformDocsEnabled,
  useSandboxCredentialsEnabled,
} from "@/lib/feature-flags/useSandboxCredentialsEnabled";
import {
  PORTAL_HOME_ROUTE,
  PORTAL_LANDING_ROUTE,
} from "@/lib/portal/portal-routes";

/**
 * Destination for the ABC brand logo. The shared landing page owns the brand
 * when it is enabled; otherwise the logo keeps the pre-landing entry points.
 */
export function useBrandHomeRoute(): string {
  const landingEnabled = useMultiPlatformDocsEnabled();
  const sandboxCredentialsEnabled = useSandboxCredentialsEnabled();

  if (landingEnabled) {
    return PORTAL_LANDING_ROUTE;
  }

  return sandboxCredentialsEnabled ? PORTAL_HOME_ROUTE : "/";
}
